import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { GlobalAuthService } from '../services/global-auth.service';
import { RolesEnum } from '../enums/roles-enum';
import { RolesService } from '../services/roles.service';

export const isAuthenticatedGuard: CanActivateFn = (_, state) => {
  const authService = inject(GlobalAuthService);
  const rolesService = inject(RolesService);

  if (state.url.includes('admin') && !rolesService.hasRoles([RolesEnum.AccountManager])) {
    return false;
  }

  if (authService.isAuthenticated()) {
    return true;
  }

  authService.login(state.url);
  return false;
};
